import { create } from 'zustand';

export const useCartStore = create((set) => ({
  itemsInCart: 0, // Initial value
  setItemsInCart: (count) => set({ itemsInCart: count }), // Update cart count
}));
